var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5666C8.60015 11.5666 9.08666 11.0801 9.08666 10.48C9.08666 9.87983 8.60015 9.39331 8 9.39331C7.39985 9.39331 6.91333 9.87983 6.91333 10.48C6.91333 11.0801 7.39985 11.5666 8 11.5666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1866 6.35331V5.51998C12.1866 3.71998 11.7533 1.33331 7.99992 1.33331C4.24659 1.33331 3.81325 3.71998 3.81325 5.51998V6.35331C1.94659 6.58665 1.33325 7.53331 1.33325 9.85998V11.1C1.33325 13.8333 2.16659 14.6666 4.89992 14.6666H11.0999C13.8333 14.6666 14.6666 13.8333 14.6666 11.1V9.85998C14.6666 7.53331 14.0533 6.58665 12.1866 6.35331ZM7.99992 12.4933C6.88659 12.4933 5.98659 11.5866 5.98659 10.48C5.98659 9.36665 6.89325 8.46665 7.99992 8.46665C9.10659 8.46665 10.0133 9.37331 10.0133 10.48C10.0133 11.5933 9.11325 12.4933 7.99992 12.4933ZM4.89992 6.29331C4.84659 6.29331 4.79992 6.29331 4.74659 6.29331V5.51998C4.74659 3.56665 5.29992 2.26665 7.99992 2.26665C10.6999 2.26665 11.2533 3.56665 11.2533 5.51998V6.29998C11.1999 6.29998 11.1533 6.29998 11.0999 6.29998H4.89992V6.29331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.88048fe128ca9ff0552081008b2ae3a7.svg";
export { ForwardRef as ReactComponent };